export const SZST_URL = 'https://szst.emof.cn/index.php/' // 社团版 上线正式
export const ONLINEHOST_EMOF = 'https://www.emof.cn/index.php/' //益魔方上线正式

// let urlStr = 'http://192.168.2.199:8026' //
let urlStr = 'https://zsglpre.emof.cn' //

let localAnStore = [
  {
    key: 'userMid',// 用户mid
    type: 'cookie'
  },
  {
    key: 'userName',// 用户姓名
    type: 'cookie'
  },
  {
    key: 'userMthumb',// 用户头像
    type: 'cookie'
  },
  {
    key: 'userRoleid',// 用户头像
    type: 'cookie'
  },
  {
    key: 'allToken',// 用户头像
    type: 'cookie'
  },
]

export default {
  urlStr, // 域名地址
  localAnStore, // 存储地址
}